import { useEffect } from "react";
import type { GameController } from "../shell/hooks/useGameController.js";
import { FlowChrome } from "../shell/ui/FlowChrome.js";

const PLAYER_INVALID_MESSAGE = "This link is broken or expired.";

export function ChallengeInvalidScreen({ game }: { game: GameController }) {
  const { state, dispatch } = game;
  const diagnostics = state.challenge?.invalidReason ?? "Invalid challenge link";

  useEffect(() => {
    if (import.meta.env.DEV && typeof console !== "undefined") {
      console.info("[desk] challenge-invalid diagnostics:", diagnostics);
    }
  }, [diagnostics]);

  return (
    <FlowChrome
      testId="screen-challenge-invalid"
      className="challenge-invalid flow-compact"
      stage="Challenge"
      title="That link fizzled"
      hook="Nothing from the link touched your shift."
      actions={
        <>
          <button
            type="button"
            className="primary"
            data-testid="challenge-start-normal"
            onClick={() => {
              dispatch({ type: "DISMISS_CHALLENGE" });
              dispatch({ type: "START_NEW_SHIFT" });
            }}
          >
            Start normal shift
          </button>
          <button
            type="button"
            className="secondary"
            data-testid="challenge-go-home"
            onClick={() => dispatch({ type: "DISMISS_CHALLENGE" })}
          >
            Desk
          </button>
        </>
      }
    >
      <div className="invalid-card" role="status">
        <p className="error" data-testid="challenge-invalid-reason">
          {PLAYER_INVALID_MESSAGE}
        </p>
        <p className="hint-line">Try a fresh link, or start a normal shift.</p>
      </div>
    </FlowChrome>
  );
}
